import React from 'react';
import PostComposer from '../components/PostComposer';

const PostComposerPage = () => {
  return (
    <div className="container-fluid" style={{ padding: 24 }}>
      <PostComposer />
    </div>
  );
};

export default PostComposerPage;
